<form [formGroup]="organizationForm">
  @if (organizationForm.controls.industry; as industry) {
    <markant-select
      id="industry"
      class="registration-form-input industry-select"
      [required]="industry | formControlIsRequired"
      formControlName="industry"
      [showLabelHint]="industry | formControlIsRequired"
      [label]="pathToTranslation + 'industry.label' | transloco"
      [placeholder]="pathToTranslation + 'industry.placeholder' | transloco"
      [outlined]="true"
      [error]="
        industry.errors
          | formControlKeyError
            : 'organization.details.fields.industry.validation'
            : showError || industry.touched || industry.dirty
          | transloco
      "
      [options]="industryOptions"
    >
    </markant-select>
  }

  @if (organizationForm.controls.gln; as gln) {
    <markant-input
      id="gln"
      data-cy="input-gln"
      class="registration-form-with-checkbox-input"
      name="gln"
      maxlength="13"
      formControlName="gln"
      [label]="pathToTranslation + 'gln.label' | transloco"
      [outlined]="true"
      [error]="
        gln.errors | formControlError: showError || gln.touched || gln.dirty
      "
      [helperCharacterCounter]="gln.invalid"
      [required]="gln | formControlIsRequired"
      [showLabelHint]="isGlnRequiredCampaign"
    ></markant-input>

    @if (!isGlnRequiredCampaign) {
      <div class="checkbox-container">
        <markant-checkbox
          id="gln_activated_checkbox"
          formControlName="glnNotAvailable"
          class="required-checkbox"
          (ngModelChange)="changeGlnRequired($event)"
        >
        </markant-checkbox>
        <span class="required-checkbox-text required-checkbox-text-gln">
          {{ pathToTranslation + 'glnRequired.label' | transloco }}
        </span>
      </div>
    }

    <p
      [style.visibility]="
        (gln.errors | formControlError: showError || gln.touched || gln.dirty)
          ? 'visible'
          : 'hidden'
      "
      class="error_message"
    >
      <markant-icon icon="m_warning" colorScheme="primary"></markant-icon>
      {{
        gln.errors
          | formControlKeyError
            : 'organization.details.fields.gln.validation'
            : showError || gln.touched || gln.dirty
          | transloco
      }}
    </p>
  }
  <markant-input
    *ngIf="organizationForm.controls['salesTaxId'] as salesTaxId"
    id="salesTaxId"
    data-cy="input-sales-tax-dd"
    class="registration-form-with-checkbox-input"
    name="salesTaxId"
    required
    [formControlName]="'salesTaxId'"
    [label]="pathToTranslation + 'salesTaxId.label' | transloco"
    [outlined]="true"
    [error]="
      salesTaxId.errors
        | formControlError: showError || salesTaxId.touched || salesTaxId.dirty
    "
    [showLabelHint]="true"
  ></markant-input>
  <div class="checkbox-container">
    <markant-checkbox
      id="taxNumber_activated_checkbox"
      formControlName="salesTaxNotAvailable"
      class="required-checkbox"
      (ngModelChange)="changeTaxNumberRequired($event)"
    >
      <span class="required-checkbox-text">
        {{ pathToTranslation + 'salesTaxIdNotAvailable.label' | transloco }}
      </span>
    </markant-checkbox>
  </div>
  <ng-container *ngIf="organizationForm.controls['salesTaxId'] as salesTaxId">
    <p
      *ngIf="
        salesTaxId.errors
          | formControlError
            : showError || salesTaxId.touched || salesTaxId.dirty
      "
      class="error_message"
    >
      <markant-icon icon="m_warning" colorScheme="primary"></markant-icon>
      {{
        salesTaxId.errors
          | formControlKeyError
            : 'organization.details.fields.salesTaxId.validation'
            : showError || salesTaxId.touched || salesTaxId.dirty
          | transloco
      }}
    </p>
  </ng-container>

  <markant-input
    id="taxNumber"
    data-cy="input-tax-number"
    *ngIf="
      organizationForm.get('salesTaxNotAvailable')?.value &&
      organizationForm.controls['taxNumber'] as taxNumber
    "
    class="registration-form-input"
    name="taxNumber"
    [formControlName]="'taxNumber'"
    required
    [showLabelHint]="true"
    [label]="pathToTranslation + 'taxNumber.label' | transloco"
    [outlined]="true"
    [error]="
      taxNumber.errors
        | formControlError: showError || taxNumber.touched || taxNumber.dirty
    "
    [errorText]="
      taxNumber.errors
        | formControlKeyError
          : 'organization.details.fields.taxNumber.validation'
          : showError || taxNumber.touched || taxNumber.dirty
        | transloco
    "
  ></markant-input>
</form>
